/**
 * @license Copyright (c) 2014-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import ClassicEditor 					from '@ckeditor/ckeditor5-editor-classic/src/classiceditor.js';
import Alignment 						from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import Autoformat 						from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import AutoImage 						from '@ckeditor/ckeditor5-image/src/autoimage.js';
import AutoLink 						from '@ckeditor/ckeditor5-link/src/autolink.js';
import BlockQuote 						from '@ckeditor/ckeditor5-block-quote/src/blockquote.js';
import Bold 							from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Essentials 						from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import FontBackgroundColor 				from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';
import FontColor 						from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import FontFamily 						from '@ckeditor/ckeditor5-font/src/fontfamily.js';
import FontSize 						from '@ckeditor/ckeditor5-font/src/fontsize.js';
import Heading 							from '@ckeditor/ckeditor5-heading/src/heading.js';
import Highlight 						from '@ckeditor/ckeditor5-highlight/src/highlight.js';
import HorizontalLine 					from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline.js';
import HtmlEmbed 						from '@ckeditor/ckeditor5-html-embed/src/htmlembed.js';
import Image 							from '@ckeditor/ckeditor5-image/src/image.js';
import ImageInsert 						from '@ckeditor/ckeditor5-image/src/imageinsert.js';
import ImageResize 						from '@ckeditor/ckeditor5-image/src/imageresize.js';
import ImageStyle 						from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar 					from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
import ImageUpload 						from '@ckeditor/ckeditor5-image/src/imageupload.js';
import Indent 							from '@ckeditor/ckeditor5-indent/src/indent.js';
import IndentBlock 						from '@ckeditor/ckeditor5-indent/src/indentblock.js';
import Italic 							from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Link 							from '@ckeditor/ckeditor5-link/src/link.js';
import LinkImage 						from '@ckeditor/ckeditor5-link/src/linkimage.js';
import List 							from '@ckeditor/ckeditor5-list/src/list.js';
import Paragraph 						from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import PasteFromOffice 					from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js';
import RemoveFormat 					from '@ckeditor/ckeditor5-remove-format/src/removeformat.js';
import SpecialCharacters 				from '@ckeditor/ckeditor5-special-characters/src/specialcharacters.js';
import SpecialCharactersArrows 			from '@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows.js';
import SpecialCharactersCurrency 		from '@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency.js';
import SpecialCharactersEssentials 		from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials.js';
import SpecialCharactersLatin 			from '@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin.js';
import SpecialCharactersMathematical 	from '@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical.js';
import SpecialCharactersText 			from '@ckeditor/ckeditor5-special-characters/src/specialcharacterstext.js';
import Strikethrough 					from '@ckeditor/ckeditor5-basic-styles/src/strikethrough.js';
import Subscript 						from '@ckeditor/ckeditor5-basic-styles/src/subscript.js';
import Superscript 						from '@ckeditor/ckeditor5-basic-styles/src/superscript.js';
import Table 							from '@ckeditor/ckeditor5-table/src/table.js';
import TableCellProperties 				from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableProperties 					from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableToolbar 					from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import TextTransformation 				from '@ckeditor/ckeditor5-typing/src/texttransformation.js';
import Underline 						from '@ckeditor/ckeditor5-basic-styles/src/underline.js';
import EditorWatchdog 					from '@ckeditor/ckeditor5-watchdog/src/editorwatchdog.js';

// Custom
import Placeholder 						from '../placeholder/placeholder';
import InsertImage 						from '../insert_image/insertImage';
import InsertDropdown 					from '../insert_dropdown/insertdropdown';
import InsertBackground					from '../insert_background/insertbackground';
import InsertAi				 		    from '../insert_ai/insertai';
import ConvertDivAttributes 			from '../allow_div/allowdivattributes';
import ChangeOrientation 				from '../change_orientation/changeorientation';
import AllowClassAttribute 				from '../allow_class/allowclass';
import Anchor 							from '../anchor/src/anchor';
import insertImageScorm					from '../insert_image/insertImageScorm';
import InsertBackgroundScorm 			from "../insert_background/insertbackgroundScorm";


class Editor extends ClassicEditor {}

// Plugins to include in the build.
Editor.builtinPlugins = [
	Alignment,
	Autoformat,
	AutoImage,
	AutoLink,
	BlockQuote,
	Bold,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	Heading,
	Highlight,
	HorizontalLine,
	HtmlEmbed,
	Image,
	ImageInsert,
	ImageResize,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	Indent,
	IndentBlock,
	Italic,
	Link,
	LinkImage,
	List,
	Paragraph,
	PasteFromOffice,
	RemoveFormat,
	SpecialCharacters,
	SpecialCharactersArrows,
	SpecialCharactersCurrency,
	SpecialCharactersEssentials,
	SpecialCharactersLatin,
	SpecialCharactersMathematical,
	SpecialCharactersText,
	Strikethrough,
	Subscript,
	Superscript,
	Table,
	TableCellProperties,
	TableProperties,
	TableToolbar,
	TextTransformation,
	Underline,
	Placeholder,
	insertImageScorm,
	InsertBackgroundScorm,
	InsertDropdown,
	InsertBackground,
	InsertAi,
	ConvertDivAttributes,
	ChangeOrientation,
	AllowClassAttribute,
	Anchor,
	InsertImage
];

export default { Editor, EditorWatchdog };
